const scopes = new Map();
// An opaque in-memory key separates private data without putting credentials
// in query keys, logs or browser storage.
export const credentialScope = token => {
  if (!token) return 'public';
  if (!scopes.has(token)) scopes.set(token, scopes.size + 1);
  return scopes.get(token);
};
